import { render, staticRenderFns } from "./CrossFadeTransition.global.vue?vue&type=template&id=a2cbcb4e&scoped=true&lang=pug&"
import script from "./CrossFadeTransition.global.vue?vue&type=script&lang=ts&"
export * from "./CrossFadeTransition.global.vue?vue&type=script&lang=ts&"
import style0 from "./CrossFadeTransition.global.vue?vue&type=style&index=0&id=a2cbcb4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cbcb4e",
  null
  
)

export default component.exports